/* SupportHours.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _23 = "@media (min-width:48rem){._1r3v1epz{padding-left:var(--ds-space-1000,5pc)}}";
const _22 = "._19bvidpf{padding-left:0}";
const _21 = "._syaz1fxt{color:var(--ds-text,#172b4d)}";
const _20 = "._18s81lvv{margin:var(--_mog0om)}";
const _19 = "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _18 = "@media (min-width:48rem){._6ytt47zb{padding:var(--_o3usm9)}}";
const _17 = "._k48p1wq8{font-weight:var(--ds-font-weight-medium,500)}";
const _16 = "._otyridpf{margin-bottom:0}";
const _15 = "._11c8lodh{font:var(--ds-font-heading-medium,normal 500 20px/24px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _14 = "._1yt4zmd4{padding:var(--_1aun1c5)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField, ErrorMessage, Field, Fieldset } from '@atlaskit/form';
import { media } from '@atlaskit/primitives/responsive';
import { H3 } from '@atlassian/mpac-primitives';
import { SelectInput } from '@atlassian/mpac-ui';
import { useState } from 'react';
import { TIMEZONE_OPTIONS } from '../../../ManagePartners/PartnerProfile/components/SupportInformation/HoursOfOperation/HoursOfOperationForm/ServiceAvailabilityFormSection/SupportHoursFormSection/constants';
import { SupportHoursHelper } from '../HelpText';
import { HOUR_OPTIONS, MINUTE_OPTIONS, REGION_OPTIONS, REGION_PLACEHOLDER_OPTION, SUPPORT_DAYS, TIMEZONE_PLACEHOLDER_OPTION, validateSupportDaysSelected, validateSupportUntilTime } from '../ManageVendorCreate.utils';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _13 = "@media (min-width:48rem){._14b5mxpn{width:6rem}}";
const _12 = "._p12fmxpn{max-width:6rem}";
const _11 = "._2lx2vrvc{flex-direction:row}";
const _10 = "._otyru2gc{margin-bottom:var(--ds-space-100,8px)}";
const _9 = "._4cvr1h6o{align-items:center}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._zulpjb7m{gap:var(--_1xs0znw)}";
const _6 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _5 = "._k48pmoej{font-weight:var(--ds-font-weight-bold,700)}";
const _4 = "._18s81j51{margin:var(--_1jdduoh)}";
const _3 = "._11c81o8v{font:var(--ds-font-body-small,normal 400 11px/1pc ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}";
const _2 = "@media (min-width:48rem){._14b5tye8{width:20rem}}";
const _ = "._1bsb1osq{width:100%}";
const FieldsetTitleH3 = null;
const SupportHoursLegend = null;
const LeftPadding = null;
const SupportHoursFromLabel = null;
const SupportHoursFromContainer = null;
const FieldWidth6 = null;
const FieldWidth20 = null;
const SupportHoursErrorWrapper = null;
const CheckboxRow = null;
function RegionTimezoneSelects(_ref) {
  let {
    setFieldValue
  } = _ref;
  const [selectedRegion, setSelectedRegion] = useState(undefined);
  const [timezoneKey, setTimezoneKey] = useState(0);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1bsb1osq _14b5tye8"]),
        children: /*#__PURE__*/_jsx(SelectInput, {
          name: "region",
          label: "Region",
          width: "100%",
          testId: "region-select",
          options: [REGION_PLACEHOLDER_OPTION, ...REGION_OPTIONS],
          helperMessage: "Choose your support office region.",
          placeholder: "Select a region",
          onChange: opt => {
            var _opt$value;
            const value = String((_opt$value = opt === null || opt === void 0 ? void 0 : opt.value) !== null && _opt$value !== void 0 ? _opt$value : '');
            const isPlaceholder = value === '';
            setSelectedRegion(isPlaceholder ? undefined : value);
            setTimezoneKey(k => k + 1);
            setFieldValue('timezone', TIMEZONE_PLACEHOLDER_OPTION);
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_1bsb1osq _14b5tye8"]),
        children: /*#__PURE__*/_jsx(SelectInput, {
          name: "timezone",
          label: "Time zone",
          width: "100%",
          options: selectedRegion ? [TIMEZONE_PLACEHOLDER_OPTION, ...TIMEZONE_OPTIONS.filter(tz => typeof tz.value === 'string' && tz.value.startsWith("".concat(selectedRegion, "/")))] : [TIMEZONE_PLACEHOLDER_OPTION],
          helperMessage: "Choose your support office's time zone.",
          placeholder: "Select a time zone",
          defaultValue: TIMEZONE_PLACEHOLDER_OPTION,
          validate: (timezoneValue, formState) => {
            const provideSupportHours = Boolean(formState === null || formState === void 0 ? void 0 : formState.provideSupportHours);
            const isPlaceholder = Array.isArray(timezoneValue) ? timezoneValue.length === 0 : !timezoneValue || (timezoneValue === null || timezoneValue === void 0 ? void 0 : timezoneValue.value) === '';
            return provideSupportHours && isPlaceholder ? 'Time zone Invalid or missing' : undefined;
          }
        }, timezoneKey)
      })]
    })]
  });
}
function TwentyFourHourSupportBody(_ref2) {
  let {
    isChecked
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_3, _4, _5, _6]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_11c81o8v _18s81j51 _k48pmoej _syaz1gjq"]),
        style: {
          "--_1jdduoh": ix("var(--ds-space-100, 8px)".concat(" 0 ", "var(--ds-space-050, 4px)"))
        },
        children: "Support time from"
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_7, _8, _9, _10, _11]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_zulpjb7m _1e0c1txw _4cvr1h6o _otyru2gc _2lx2vrvc"]),
        style: {
          "--_1xs0znw": ix("var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-100, 8px)"))
        },
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _p12fmxpn _14b5mxpn"]),
            children: /*#__PURE__*/_jsx(SelectInput, {
              name: "supportHoursOfOperationFromHour",
              label: "",
              width: "100%",
              options: HOUR_OPTIONS,
              placeholder: "00",
              defaultValue: HOUR_OPTIONS[0],
              isDisabled: isChecked
            })
          })]
        }), /*#__PURE__*/_jsx("span", {
          children: ":"
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _p12fmxpn _14b5mxpn"]),
            children: /*#__PURE__*/_jsx(SelectInput, {
              name: "supportHoursOfOperationFromMinute",
              label: "",
              width: "100%",
              options: MINUTE_OPTIONS,
              placeholder: "00",
              defaultValue: MINUTE_OPTIONS[0],
              isDisabled: isChecked
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_3, _4, _5, _6]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_11c81o8v _18s81j51 _k48pmoej _syaz1gjq"]),
        style: {
          "--_1jdduoh": ix("var(--ds-space-100, 8px)".concat(" 0 ", "var(--ds-space-050, 4px)"))
        },
        children: "Support time until"
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_7, _8, _9, _10, _11]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_zulpjb7m _1e0c1txw _4cvr1h6o _otyru2gc _2lx2vrvc"]),
        style: {
          "--_1xs0znw": ix("var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-100, 8px)"))
        },
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _p12fmxpn _14b5mxpn"]),
            children: /*#__PURE__*/_jsx(SelectInput, {
              name: "supportHoursOfOperationUntilHour",
              label: "",
              width: "100%",
              options: HOUR_OPTIONS,
              placeholder: "00",
              defaultValue: HOUR_OPTIONS[0],
              isDisabled: isChecked
            })
          })]
        }), /*#__PURE__*/_jsx("span", {
          children: ":"
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_, _12, _13]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1bsb1osq _p12fmxpn _14b5mxpn"]),
            children: /*#__PURE__*/_jsx(SelectInput, {
              name: "supportHoursOfOperationUntilMinute",
              label: "",
              width: "100%",
              options: MINUTE_OPTIONS,
              placeholder: "00",
              defaultValue: MINUTE_OPTIONS[0],
              isDisabled: isChecked
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_10]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_otyru2gc"]),
        children: /*#__PURE__*/_jsx(Field, {
          name: "supportHoursOfOperationTimeValidation",
          validate: validateSupportUntilTime,
          children: _ref3 => {
            let {
              meta: {
                error,
                submitFailed
              }
            } = _ref3;
            return error && submitFailed ? /*#__PURE__*/_jsx(ErrorMessage, {
              testId: "support-hours-of-operation-until-error",
              children: error
            }) : null;
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_3, _4, _5, _6]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_11c81o8v _18s81j51 _k48pmoej _syaz1gjq"]),
        style: {
          "--_1jdduoh": ix("var(--ds-space-100, 8px)".concat(" 0 ", "var(--ds-space-050, 4px)"))
        },
        children: "Days supported"
      })]
    }), SUPPORT_DAYS.map(d => /*#__PURE__*/_jsx(CheckboxField, {
      name: d.name,
      children: _ref4 => {
        let {
          fieldProps: dayFieldProps
        } = _ref4;
        return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, dayFieldProps), {}, {
          label: d.key,
          name: d.name
        }));
      }
    }, d.name)), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_10]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_otyru2gc"]),
        children: /*#__PURE__*/_jsx(Field, {
          name: "supportDaysValidation",
          validate: validateSupportDaysSelected,
          children: _ref5 => {
            let {
              meta: {
                error,
                submitFailed
              }
            } = _ref5;
            return error && submitFailed ? /*#__PURE__*/_jsx(ErrorMessage, {
              testId: "support-days-error",
              children: error
            }) : null;
          }
        })
      })]
    })]
  });
}
export const SupportHours = _ref6 => {
  let {
    setFieldValue
  } = _ref6;
  return /*#__PURE__*/_jsxs(Fieldset, {
    legend: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_14, _15, _16, _17, _18]
      }), /*#__PURE__*/_jsx(H3, {
        className: ax(["_1yt4zmd4 _11c8lodh _otyridpf _k48p1wq8 _6ytt47zb"]),
        style: {
          "--_1aun1c5": ix("var(--ds-space-300, 24px)".concat(" 0 ", "var(--ds-space-050, 4px)")),
          "--_o3usm9": ix("var(--ds-space-400, 32px)".concat(" 0 ", "var(--ds-space-025, 2px)"))
        },
        children: "Support hours"
      })]
    }),
    children: [/*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_19, _20, _21]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_11c82smr _18s81lvv _syaz1fxt"]),
        style: {
          "--_mog0om": ix("var(--ds-space-050, 4px)".concat(" 0 ", "var(--ds-space-250, 20px)"))
        },
        children: SupportHoursHelper
      })]
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_22, _23]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_19bvidpf _1r3v1epz"]),
        children: /*#__PURE__*/_jsx(CheckboxField, {
          name: "provideSupportHours",
          children: _ref7 => {
            let {
              fieldProps
            } = _ref7;
            return /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, fieldProps), {}, {
                label: "Provide support hours",
                name: "provideSupportHours"
              })), fieldProps.isChecked && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(RegionTimezoneSelects, {
                  setFieldValue: setFieldValue
                }), /*#__PURE__*/_jsx(CheckboxField, {
                  name: "twentyFourHourSupport",
                  defaultIsChecked: true,
                  children: _ref8 => {
                    let {
                      fieldProps: twentyFourHourSupportFieldProps
                    } = _ref8;
                    return /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsxs(CC, {
                        children: [/*#__PURE__*/_jsx(CS, {
                          children: [_10]
                        }), /*#__PURE__*/_jsx("div", {
                          className: ax(["_otyru2gc"]),
                          children: /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({}, twentyFourHourSupportFieldProps), {}, {
                            label: "24 hour support",
                            name: "twentyFourHourSupport"
                          }))
                        })]
                      }), /*#__PURE__*/_jsx(TwentyFourHourSupportBody, {
                        isChecked: Boolean(twentyFourHourSupportFieldProps.isChecked)
                      })]
                    });
                  }
                })]
              })]
            });
          }
        })
      })]
    })]
  });
};